import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Container } from './DotLoader.styles';

const DotLoaderComponent = ({ className }) => {
  return <Container className={className} />;
};

DotLoaderComponent.propTypes = {
  className: PropTypes.string,
};

export const DotLoader = memo(DotLoaderComponent);
